<template>
  <div id="googleLoginContainer" class="google-login-container"></div>
</template>

<script>
import jwt_decode from 'jwt-decode';
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue && Vue.use(VueCookies, { expires: '1h'})

/**
 * client_id
 * 线上正式: 364160055684-ghrjq2osbguv0d6ei6n2lkhgs8dmi2ou.apps.googleusercontent.com
 * 本地测试: 933223160708-l70s6r4umtsebt0a0ma4t1ehi59lcjeu.apps.googleusercontent.com
 * onloadOptions中传的client_id, 默认使用‘线上正式’
*/
const script_gsi_client = 'https://accounts.google.com/gsi/client';

export default {
  props: {
    onloadOptions: {
      type: Object,
      default: () => {
        return {
          client_id: '364160055684-ghrjq2osbguv0d6ei6n2lkhgs8dmi2ou.apps.googleusercontent.com',
          login_uri: '',
          auto_prompt: false,
          auto_select: false
        }
      }
    },
    signinOptions: {
      type: Object,
      default: () => {
        return {
          type: 'standard',
          size: 'large',
          theme: 'outline',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'center',
          width: '',
          locale: ''
        }
      }
    },
    introduce: {
      type: Object,
      default: () => {
        return {
          label: '“通过 Google JavaScript API 登录”参考文档',
          link: 'https://developers.google.com/identity/gsi/web/reference/js-reference?hl=zh-cn'
        }
      }
    }
  },
  head() {
    return {
      script: [
        {
          src: script_gsi_client,
          defer: true,
          async: true,
          callback: () => {
            this.$nextTick(() => {
              this.initGoogleLogin();
            })
          }
        }
      ]
    }
  },
  created() {
    this.initOnEvent();
    window.addEventListener('error', e => {
      let target = e.target;
      if(target.src == script_gsi_client) {
        if(typeof moo == 'undefined') return;
        if(moo && moo.$bus) {
          moo.$bus.$emit('rocket:remote:common/google-login:client-library-error');
        }
      }
    }, true)
  },
  methods: {
    initGoogleLogin() {
      // 监听 onloadOptions 的传参
      this.watch_options('onloadOptions', (onloadOptions) => {
        if(onloadOptions['client_id']) {
          this.google_initialize(onloadOptions);
          // 监听 signinOptions 的传参, renderButton 需在 initialize后
          // 所以watch这样处理
          this.watch_options('signinOptions', (signinOptions) => {
            this.google_renderButton(signinOptions);
          })
        }

        // 验证登陆态 - 查看cookie有无credential信息
        let { isLogin, credential } = this.verifyLoginState();
        if(isLogin) {
          this.loginSuccess(credential);
        }else {
          // 一键登录
          if(this.onloadOptions['auto_prompt']) {
            google.accounts.id.prompt();
          }
        }
      });
    },
    watch_options(name, callback) {
      this.$watch(name, {
        handler(options) {
          callback(options);
        },
        immediate: true,
        deep: true
      });
    },
    google_initialize(options) {
      google.accounts.id.initialize({
        client_id: options['client_id'],
        login_uri: options['login_uri'],
        auto_select: options['auto_select'],
        callback: this.handleCredentialResponse
      });
    },
    google_renderButton(options) {
      google.accounts.id.renderButton(
        document.getElementById("googleLoginContainer"),
        {
          type: options['type'],
          size: options['size'],
          theme: options['theme'],
          text: options['text'],
          shape: options['shape'],
          logo_alignment: options['logo_alignment'],
          width: options['width'],
          locale: options['locale'],
          click_listener: this.onClickHandler
        }
      );
    },
    handleCredentialResponse(response) {
      // 存储登陆态 -> cookie
      this.$cookies.set('g_ID_credential', JSON.stringify(response.credential));

      this.loginSuccess(response.credential);
    },
    verifyLoginState() {
      let isLogin = false;
      let credential = this.$cookies.get('g_ID_credential');

      if(credential) {
        isLogin = true;
        credential = JSON.parse(credential);
      }

      return { isLogin, credential };
    },
    loginSuccess(credential) {
      // 响应登陆态
      const p = jwt_decode(credential);

      // console.log('--- 已登陆 ---')
      // console.log("ID_TOKEN: " + credential);
      // console.log("CLIENT_ID: " + p.aud);
      // console.log("USER ID: " + p.sub);
      // console.log('Full Name: ' + p.name);
      // console.log('Given Name: ' + p.given_name);
      // console.log('Family Name: ' + p.family_name);
      // console.log("Image URL: " + p.picture);
      // console.log("Email: " + p.email);

      if(typeof moo == 'undefined') return;
      if(moo && moo.$bus) {
        moo.$bus.$emit('rocket:remote:common/google-login:success', credential, p.aud, p.sub, p.name, p.given_name, p.family_name, p.picture, p.email);
      }
    },
    initOnEvent() {
      if(typeof moo == 'undefined') return;
      if(moo && moo.$bus) {
        // 退出登陆
        moo.$bus.$on('rocket:remote:common/google-login:sign-out', () => {
          this.$cookies.remove('g_ID_credential');
          
          // 退出登陆后执行
          let credential = this.$cookies.get('g_ID_credential');
          if(!credential) {
            moo.$bus.$emit('rocket:remote:common/google-login:after-sign-out');
            google.accounts.id.disableAutoSelect();
          }
        })
      }
    },
    onClickHandler() {
      if(typeof moo == 'undefined') return;
      if(moo && moo.$bus) {
        moo.$bus.$emit('rocket:remote:common/google-login:click-btn');
      }
    }
  }
}
</script>